import React, { useEffect, useState } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail} from "firebase/auth";
import { getDatabase, ref, update } from "firebase/database";
import { auth } from "../../firebase";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const LoginForm = () => {

  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!window.bootstrap) {
      console.error("Bootstrap JS not loaded.");
    }

    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
  
    return unsubscribe;
  }, []);

      const signIn = async () => {
        setError("");

        if (!email || !password) {
          setError("Please enter both email and password.");
          return;
        }

        try {
          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          const user = userCredential.user;

          // Update last login timestamp
          const now = new Date();
          const USERLASTLOGIN = `${String(now.getDate()).padStart(2, "0")}/${String(now.getMonth() + 1).padStart(2, "0")}/${now.getFullYear()} : ${String(now.getHours()).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}`;
          
          const database = getDatabase();
          await update(ref(database, "USERS/" + user.uid), {
            USERLASTLOGIN: USERLASTLOGIN
          });

          const modalEl = document.getElementById("LoginModal");
          if (modalEl) {
            const modal = window.bootstrap.Modal.getInstance(modalEl);
            modal?.hide();
          }
        } catch (err) {
          console.error("Login error:", err.message);
          setError("Invalid email or password.");
        }
      };

      if (user) {
        navigate("/", { replace: true });
        return;
      }
      
      const ResetPasswordModal = () => {
        const modal = new window.bootstrap.Modal(document.getElementById("ResetPasswordModal"));
        modal.show();
      };

      const handleResetPassword = async () => {
      const email = document.getElementById("ResetEmail")?.value; // get email input

      if (!email) {
        alert("Please enter your email.");
        return;
      }

      try {
        await sendPasswordResetEmail(auth, email);
        alert("Password reset email sent! Check your inbox.");
        const modal = window.bootstrap.Modal.getInstance(document.getElementById("ResetPasswordModal"));
        modal.hide();
      } catch (error) {
        console.error("Error sending password reset email:", error);
        alert(error.message);
      }
    };


    
  return (
    <div className="mt-5 mb-5">
      {user ? (
        <p>
          You're already logged in.{" "}
          <Link to="/" className="text-primary">
            Go to Home
          </Link>
        </p>
      ) : (
        <>
          <h1 className="text-center mt-5">Login</h1>

            <div className="row justify-content-center">
              <div className="col-md-5">
                <div className="filter-section"></div>
              </div>
            </div>

          <div className="container mb-5">
            <div className="row justify-content-center">
              <div className="col-md-5">
                <label htmlFor="Login_Email" className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="Login_Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
            </div>

            <div className="row justify-content-center mt-3">
              <div className="col-md-5">
                <label htmlFor="Login_Password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="Login_Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            {error && (
              <div className="row justify-content-center mt-3">
                <div className="col-md-5">
                  <div className="alert alert-danger p-2">{error}</div>
                </div>
              </div>
            )}

            <div className="row justify-content-center mt-3">
              <div className="col-md-5">
                <div className="row justify-content-between">
                  <div className="col-6">
                    <button
                      type="button"
                      className="btn btn-link p-0 text-primary"
                      onClick={ResetPasswordModal}
                    >
                      Forgot Password?
                    </button>
                  </div>
                  <div className="col-6 text-end">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={signIn}
                    >
                      Login
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="row justify-content-center mt-3">
              <div className="col-md-5">
                <p className="small">
                  Don’t have an account?{" "}
                  <Link to="/SignUp" className="text-primary">
                    Sign Up
                  </Link>
                </p>
              </div>
            </div>

            <div className="row justify-content-center mt-3">

            </div>
          </div>

                {/* Password Reset */}
      <div
        className="modal fade"
        id="ResetPasswordModal"
        tabIndex="-1"
        aria-labelledby="ResetPasswordModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="row p-4">

              <div className="col-6">
              <h3 className="modal-title" id="LoginModalLabel">
                Reset Password
              </h3>
              </div>

              <div className="col-6 text-end">
              <button
                type="button"
                className="closee"
                data-bs-dismiss="modal"
                aria-label="Close"
              > <i className="bi bi-x-lg"></i> </button>
              </div>

            </div>
            <div className="modal-body">


              <div className="row">
                <div className="col-md-12">
                  <div className="mb-5">
                    <label htmlFor="ResetEmail" className="form-label">Email</label>
                    <input type="email" className="form-control" id="ResetEmail" />
                  </div>
                </div>
              </div>


                <div className="row">
                <div className="col-md-12 text-end">
                  <div className="mb-2">
                    <button type="button" className="btn btn-primary" onClick={handleResetPassword}>Send Reset Link</button>
                  </div>
                </div>
              </div>
           
             
            </div>
          </div>
        </div>
      </div>

        </>
      )}
    </div>
  );
};

export default LoginForm;
